import polygons from "./musclePolygons";
import { targets, bodyParts } from "../queryStrings";

const muscleData = {
  skull: {
    id: 'skull',
    displayName: "Head",
    classes: bodyParts.neck,
    coords: {
      anterior: polygons.skull.anterior,
      posterior: polygons.skull.posterior,
    },
    paired: false,
    anterior: (polygons.skull.anterior),
    posterior: (polygons.skull.posterior),
  },
  hand: {
    id: 'hand',
    displayName: "Hand",
    classes: bodyParts.lowerArms,
    coords: polygons.hand,
    paired: true,
    anterior: true,
    posterior: true,
    rotation: 1.25,
    xOffset: -10,
    yOffset: 0,
  },
  foot: {
    id: 'foot',
    displayName: "Foot",
    classes: bodyParts.lowerLegs,
    coords: polygons.foot,
    paired: true,
    anterior: (polygons.foot),
    posterior: (polygons.foot),
    rotation: -2,
    xOffset: 2,
    yOffset: 1,
  },
  trapezius: {
    id: targets.traps,
    displayName: "Trapezius",
    classes: [bodyParts.back, bodyParts.neck, bodyParts.shoulders],
    coords: {
      anterior: polygons.trapezius.anterior,
      posterior: polygons.trapezius.posterior,
    },
    paired: true,
    rotation: -1.25,
    xOffset: 1,
    yOffset: 1,
  },
  neck: {
    id: bodyParts.neck,
    displayName: "Neck",
    classes: bodyParts.neck,
    coords: { 
      anterior: polygons.neck.anterior,
      posterior: polygons.neck.posterior,
     },
    paired: false,
    anterior: (polygons.neck.anterior),
    posterior: (polygons.neck.posterior),
  },
  chest: {
    id: targets.pectorals,
    displayName: "Pectorals",
    classes: bodyParts.chest,
    coords: polygons.chest,
    paired: true,
    anterior: true,
    posterior: false,
    rotation: -1,
    yOffset: 0,
  },
  serratusAnterior: {
      id: targets.serratusAnterior,
      displayName: "Serratus Anterior",
      classes: bodyParts.chest,
      coords: polygons.serratusAnterior,
      paired: true,
      anterior: true,
      posterior: false,
      xOffset: -1,
  },
  abdomen: {
    id: targets.abs,
    displayName: "Abdominals",
    classes: bodyParts.waist,
    coords: polygons.abdomen,
    paired: false,
    anterior: true,
    posterior: false,
  },
  latissimusDorsi: {
    id: targets.lats,
    displayName: "Latissimus Dorsi",
    classes: [bodyParts.waist, bodyParts.back],
    coords: {
      anterior: polygons.latissimusDorsi.anterior,
      posterior: polygons.latissimusDorsi.posterior,
    },
    paired: true,
    xOffset: -2,
    rotation: -1.5,
    yOffset: 2,
  },
  rhomboids: {
      id: targets.upperBack,
      displayName: "Rhomboids",
      classes: bodyParts.back,
      coords: polygons.rhomboids,
      paired: true,
      anterior: false,
      posterior: true,
      rotation: -2,
      xOffset: -1,
  },
  shoulder: {
    id: targets.delts,
    displayName: "Shoulder",
    classes: bodyParts.shoulders,
    coords: {
      anterior: polygons.shoulder.anterior,
      posterior: polygons.shoulder.posterior,
    },
    paired: true,
    xOffset: -1,
    yOffset: 2,
    rotation: -1.5,
  },
  biceps: {
    id: targets.biceps,
    displayName: "Biceps",
    classes: bodyParts.upperArms,
    coords: polygons.biceps,
    paired: true,
    anterior: true,
    posterior: false,
    xOffset: -2,
    rotation: -2,
  },
  triceps: {
    id: targets.triceps,
    displayName: "Triceps",
    classes: bodyParts.upperArms,
    coords: polygons.triceps,
    paired: true,
    anterior: false,
    posterior: true,
    xOffset: -2,
    rotation: -2,
  },
  forearm: {
    id: targets.forearms,
    displayName: "Forearm",
    classes: bodyParts.lowerArms,
    coords: polygons.forearm,
    paired: true,
    anterior: true,
    posterior: true,
    xOffset: -7,
    rotation: -1,
  },
  quadriceps: {
    id: targets.quadriceps,
    displayName: "Quadriceps",
    classes: bodyParts.lowerLegs,
    coords: polygons.quadriceps,
    paired: true,
    anterior: true,
    posterior: false,
    xOffset: -7,
    rotation: 0.5,
  },
  abductor: {
    id: targets.abductors,
    displayName: "Abductor",
    classes: [bodyParts.upperLegs, bodyParts.waist],
    coords: {
        anterior: polygons.abductor.anterior,
        posterior: polygons.abductor.posterior,
    },
    paired: true,
    xOffset: -8,
    rotation: 1,
  },
  adductor: {
    id: targets.adductors,
    displayName: "Adductor",
    classes: bodyParts.upperLegs,
    coords: polygons.adductor,
    paired: true,
    anterior: true,
    posterior: false,
    xOffset: -7,
    rotation: -1,
  },
  lowerLeg: {
    id: targets.calves,
    displayName: "Lower Leg",
    classes: bodyParts.lowerLegs,
    coords: polygons.lowerLeg,
    paired: true,
    anterior: true,
    posterior: true,
    xOffset: -3,
    rotation: 2,
  },
  gluteus: {
    id: targets.glutes,
    displayName: "Gluteus",
    classes: bodyParts.upperLegs,
    coords: polygons.gluteus,
    paired: true,
    anterior: false,
    posterior: true,
    xOffset: -8,
  },
  hamstring: {
    id: targets.hamstrings,
    displayName: "Hamstring",
    classes: bodyParts.upperLegs,
    coords: polygons.hamstring,
    paired: true,
    anterior: false,
    posterior: true,
    xOffset: -8,
    rotation: 1,
  },
};

export default muscleData;
